import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ButtonGroup,
} from 'reactstrap';
import classnames from 'classnames';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import CrmCustomerTable from '../components/CrmCustomerTable';
import CrmDataTable from '../components/CrmDataTable';
import CrmCategoryTable from '../components/CrmCategoryTable';

class CrmCustomerPage extends React.Component {
  _isMounted = true;
  comp = StorageService.getSession('selected_org');
  constructor(props) {
    super(props);
    this.state = {
      Role: this.comp.Role,
      redirect: false,
      isLoading: true,
      customerList: [],
      filteredList: [],
      searchKey: '',
      tabList: [{ name: 'Customer' }, { name: 'Category' }],
      activeTab: '1',
    };
  }

  componentDidMount() {}

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  detail = id => {
    console.log(`/crmcustomer/${id}`);
    this.props.history.push({
      pathname: `/crmcustomer/${id}`,
    });
  };

  render() {
    const { activeTab, Role } = this.state;
    return (
      <Page
        className="CrmCustomerPage"
        title="Customer"
        breadcrumbs={[{ name: 'Customer', active: true, path: '/crmcustomer' }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        {(Role === 'Superuser' || Role === 'Admin' || Role === 'Manager') && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display main">
                <CardBody>
                  <Nav tabs className="ps-tab">
                    {this.state.tabList.map((item, index) => {
                      return (
                        <NavItem key={item.name}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggleTab((index + 1).toString());
                            }}
                          >
                            {item.name}
                          </NavLink>
                        </NavItem>
                      );
                    })}
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <CrmCustomerTable detail={this.detail} />
                    </TabPane>
                    {/* <TabPane tabId="2" className="py-3">
                      <CrmDataTable />
                    </TabPane> */}
                    <TabPane tabId="2" className="py-3">
                      <CrmCategoryTable />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Page>
    );
  }
}

export default CrmCustomerPage;
